export const navLinks = [
  { label: "首页", href: "#top" },
  { label: "话题墙", href: "#topics" },
  { label: "最新爆料", href: "#latest" },
  { label: "热议榜", href: "#ranking" },
  { label: "资源入口", href: "#resources" },
  { label: "争议回顾", href: "#controversy" },
  { label: "讨论区", href: "#discussion" },
];

export const quickStats = [
  { value: "1,286", label: "累计瓜料条目", icon: "ri-inbox-archive-line" },
  { value: "342", label: "关联话题标签", icon: "ri-price-tag-3-line" },
  { value: "97", label: "近期争议事件", icon: "ri-alarm-warning-line" },
  { value: "24h", label: "爆料更新频率", icon: "ri-flashlight-line" },
];

export const heroFeatured = {
  badge: "本周期重点追踪",
  title: "从旧访谈片段到深夜同框，事件脉络一次看清",
  desc: "把分散在讨论区、评论区与往期归档中的线索归拢到同一条时间线，帮你在追瓜之前先弄明白来龙去脉，避免被截取片段带偏节奏。",
  image:
    "https://readdy.ai/api/search-image?query=warm%20peach%20and%20coral%20toned%20abstract%20editorial%20background%20with%20soft%20gradients%2C%20glossy%20silk%20texture%2C%20delicate%20rose%20petals%2C%20elegant%20feminine%20magazine%20mood%2C%20high%20detail%20studio%20lighting%2C%20lush%20warm%20color%20harmony&width=1200&height=800&seq=guapi-hero-feat-01&orientation=landscape",
  meta: { time: "2 小时前更新", heat: "热度 98.2w", source: "线索组整理" },
  href: "#latest",
};

export const heroSideCards = [
  {
    id: "side-1",
    badge: "热议中",
    title: "当事回应与旧料出现出入，评论区吵翻了",
    time: "4 小时前",
    heat: "热度 66.4w",
    image:
      "https://readdy.ai/api/search-image?query=soft%20peach%20glow%20abstract%20backdrop%20with%20flowing%20amber%20light%20and%20silky%20fabric%20folds%2C%20warm%20romantic%20editorial%20aesthetic%2C%20minimal%20composition%2C%20high%20detail%2C%20consistent%20warm%20studio%20lighting&width=800&height=500&seq=guapi-hero-side-01&orientation=landscape",
    href: "#ranking",
  },
  {
    id: "side-2",
    badge: "资料入口",
    title: "完整时间线资料包已归档，可按年份翻查",
    time: "6 小时前",
    heat: "下载 3.1w",
    image:
      "https://readdy.ai/api/search-image?query=warm%20rose%20gold%20abstract%20gradient%20background%20with%20subtle%20sparkle%20and%20soft%20bokeh%2C%20luxurious%20feminine%20mood%2C%20smooth%20blur%2C%20high%20detail%2C%20cohesive%20peach%20and%20amber%20color%20palette&width=800&height=500&seq=guapi-hero-side-02&orientation=landscape",
    href: "#resources",
  },
];

export const hotTopics = [
  { label: "最新瓜", count: "128", hot: true },
  { label: "私密线索", count: "96", hot: true },
  { label: "绯闻时间线", count: "88", hot: false },
  { label: "当事回应", count: "74", hot: true },
  { label: "旧料重提", count: "69", hot: false },
  { label: "同框画面", count: "61", hot: false },
  { label: "聊天记录", count: "57", hot: true },
  { label: "工作室声明", count: "52", hot: false },
  { label: "路透照片", count: "48", hot: false },
  { label: "争议言论", count: "44", hot: false },
  { label: "粉丝争议", count: "41", hot: false },
  { label: "代言变动", count: "37", hot: false },
  { label: "造型讨论", count: "35", hot: false },
  { label: "综艺片段", count: "33", hot: false },
  { label: "机场街拍", count: "30", hot: false },
  { label: "数据对比", count: "27", hot: false },
  { label: "往期归档", count: "24", hot: false },
  { label: "讨论热帖", count: "21", hot: false },
];

export const latestLeaks = [
  {
    id: "leak-1",
    title: "深夜同框画面流出？时间点与行程记录对不上引猜疑",
    summary: "有网友对比公开行程后指出画面拍摄时间存在疑点，讨论区已就真假分成两派，整理出三种解释版本。",
    image:
      "https://readdy.ai/api/search-image?query=warm%20peach%20tone%20still%20life%20of%20cosmetics%20and%20silk%20ribbon%20on%20cream%20background%2C%20soft%20editorial%20lighting%2C%20delicate%20feminine%20still%20life%2C%20high%20detail%2C%20consistent%20warm%20palette&width=800&height=600&seq=guapi-leak-01&orientation=landscape",
    tags: ["同框画面", "行程对比"],
    time: "2 小时前",
    heat: "98.2w",
    comments: "1,204",
  },
  {
    id: "leak-2",
    title: "一段旧访谈被翻出，一句无心之言成新一轮讨论焦点",
    summary: "三年前的访问被重新剪辑传播，上下文被截断后语义发生变化，本站整理出完整原片段落供对照。",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20warm%20coral%20light%20leaks%20and%20soft%20lens%20flare%20over%20cream%20paper%20texture%2C%20minimal%20editorial%20background%2C%20elegant%20warm%20tone%2C%20high%20detail&width=800&height=600&seq=guapi-leak-02&orientation=landscape",
    tags: ["旧料重提", "争议言论"],
    time: "5 小时前",
    heat: "82.6w",
    comments: "986",
  },
  {
    id: "leak-3",
    title: "工作室声明与本人动态口径不一，粉丝开始站队",
    summary: "同一事件出现两份表述，措辞差异被逐字拆解，梳理出四处在时间与用词上的明显出入。",
    image:
      "https://readdy.ai/api/search-image?query=stylish%20woman%20silhouette%20fashion%20editorial%20in%20warm%20amber%20backlight%2C%20elegant%20minimal%20mood%2C%20soft%20focus%2C%20high%20detail%2C%20cream%20studio%20background&width=800&height=600&seq=guapi-leak-03&orientation=landscape",
    tags: ["工作室声明", "粉丝争议"],
    time: "昨天",
    heat: "76.3w",
    comments: "1,542",
  },
  {
    id: "leak-4",
    title: "聊天记录截图疯传，多处标点与头像被指有明显拼接痕",
    summary: "已有多位网友指出截图细节问题，站内整理了对比版本，提醒先核实再转发，避免二次传播失实内容。",
    image:
      "https://readdy.ai/api/search-image?query=luxury%20silk%20fabric%20draping%20in%20peach%20and%20rose%20tones%20on%20soft%20cream%20studio%20background%2C%20elegant%20texture%2C%20editorial%20still%20life%2C%20high%20detail&width=800&height=600&seq=guapi-leak-04&orientation=landscape",
    tags: ["聊天记录", "事实核查"],
    time: "昨天",
    heat: "71.9w",
    comments: "878",
  },
  {
    id: "leak-5",
    title: "路透照引发新猜测，取景地与公开通告单高度重合",
    summary: "镜头中的背景建筑与通告单地点被指一致，讨论从照片本身延伸到拍摄期间的行程安排。",
    image:
      "https://readdy.ai/api/search-image?query=modern%20interior%20with%20warm%20peach%20sunlight%20and%20sheer%20curtain%2C%20cozy%20minimal%20aesthetic%2C%20soft%20shadows%2C%20editorial%20photography%2C%20high%20detail&width=800&height=600&seq=guapi-leak-05&orientation=landscape",
    tags: ["路透照片", "行程对比"],
    time: "2 天前",
    heat: "63.5w",
    comments: "742",
  },
  {
    id: "leak-6",
    title: "代言版位悄悄更换，品牌方动态被解读出不同信号",
    summary: "官网与合作方页面上的露出位置发生调整，被部分网友视为态度信号，也有人认为只是常规排期。",
    image:
      "https://readdy.ai/api/search-image?query=golden%20hour%20bokeh%20lights%20over%20soft%20coral%20gradient%2C%20dreamy%20abstract%20background%2C%20elegant%20warm%20tones%2C%20high%20detail%2C%20minimal%20composition&width=800&height=600&seq=guapi-leak-06&orientation=landscape",
    tags: ["代言变动", "数据对比"],
    time: "2 天前",
    heat: "58.1w",
    comments: "613",
  },
];

export const hotRanking = [
  { rank: 1, title: "深夜同框画面真伪之争持续发酵", heat: "98.2w", trend: "up", tag: "同框画面" },
  { rank: 2, title: "旧访谈片段被重新剪辑传播", heat: "82.6w", trend: "up", tag: "旧料重提" },
  { rank: 3, title: "工作室声明与本人动态口径对比", heat: "76.3w", trend: "flat", tag: "工作室声明" },
  { rank: 4, title: "聊天记录截图多处细节被质疑", heat: "71.9w", trend: "up", tag: "聊天记录" },
  { rank: 5, title: "路透照取景地与通告单重合", heat: "63.5w", trend: "down", tag: "路透照片" },
  { rank: 6, title: "代言版位调整引发态度解读", heat: "58.1w", trend: "up", tag: "代言变动" },
  { rank: 7, title: "机场街拍造型成造型讨论新焦点", heat: "44.7w", trend: "flat", tag: "造型讨论" },
  { rank: 8, title: "综艺未播片段预告引发预告猜想", heat: "39.2w", trend: "down", tag: "综艺片段" },
  { rank: 9, title: "往期争议言论被集中整理重提", heat: "33.8w", trend: "up", tag: "争议言论" },
  { rank: 10, title: "数据对比贴引发新一轮粉丝讨论", heat: "28.4w", trend: "flat", tag: "数据对比" },
];

export const resourceEntries = [
  {
    id: "res-1",
    icon: "ri-file-list-3-line",
    title: "完整时间线资料包",
    desc: "按年份归档的关键节点梳理，含出处标注，方便快速回溯。",
    meta: "PDF · 约 42 页",
    action: "立即获取",
  },
  {
    id: "res-2",
    icon: "ri-image-2-line",
    title: "该事件高清图集",
    desc: "按时间排序的画面素材集合，已做打码与水印处理。",
    meta: "图集 · 128 张",
    action: "进入查看",
  },
  {
    id: "res-3",
    icon: "ri-chat-history-line",
    title: "讨论区精华合辑",
    desc: "把高赞分析与反向观点整理成对照稿，避免只看一面之词。",
    meta: "合辑 · 36 篇",
    action: "一键翻阅",
  },
  {
    id: "res-4",
    icon: "ri-node-tree",
    title: "事件脉络关系图",
    desc: "人物、时间、话题之间的关联以图形式呈现，一目了然。",
    meta: "图谱 · 可缩放",
    action: "打开图谱",
  },
  {
    id: "res-5",
    icon: "ri-download-2-line",
    title: "往期瓜料打包归档",
    desc: "早期已告一段落的话题统一收进归档包，随时离线保存。",
    meta: "归档 · 2.6 GB",
    action: "开始下载",
  },
  {
    id: "res-6",
    icon: "ri-notification-3-line",
    title: "爆料更新提醒",
    desc: "订阅关注话题后，新线索出现时第一时间收到站内提醒。",
    meta: "提醒 · 可退订",
    action: "开启提醒",
  },
];

export const controversyTimeline = [
  {
    year: "2019",
    title: "早期访谈片段首次流出",
    desc: "当时仅在小范围传播，未形成规模讨论，多数网友并未留意。",
  },
  {
    year: "2021",
    title: "合作方页面露出调整被注意到",
    desc: "版位变化被部分网友解读为态度信号，随后逐渐淡出讨论。",
  },
  {
    year: "2023",
    title: "综艺未播片段引发第一轮猜想",
    desc: "预告剪辑方式引起争议，工作室发布简短说明后平息。",
  },
  {
    year: "2024",
    title: "机场街拍与造型讨论集中出现",
    desc: "造型风格的明显转变成为话题，讨论热度维持了约两周。",
  },
  {
    year: "2025",
    title: "旧料被集中翻出并重新剪辑传播",
    desc: "多条早期素材被拼接使用，本站开始系统性建立时间线资料。",
  },
  {
    year: "2026",
    title: "深夜同框画面与声明口径之争",
    desc: "当前正在持续的讨论事件，真伪与用语差异仍是核心争点。",
  },
];

export const hotDiscussions = [
  {
    id: "dis-1",
    name: "蜜桃观察员",
    avatar: "蜜",
    time: "38 分钟前",
    content: "把三年前的完整原片和现在的剪辑版放在一起看，语境差得不是一点半点，建议大家先看原片再下结论。",
    likes: "1,286",
    replies: "214",
  },
  {
    id: "dis-2",
    name: "只看线索不站队",
    avatar: "线",
    time: "1 小时前",
    content: "时间线资料包做得挺细，按年份翻比在评论区一条条扒效率高多了，出处标注这点必须给个赞。",
    likes: "942",
    replies: "156",
  },
  {
    id: "dis-3",
    name: "爱吃桃子的阿棠",
    avatar: "棠",
    time: "2 小时前",
    content: "截图拼接痕迹是真的挺明显的，标点和头像边缘都对不上，转发前还是先自己存一份原图对比一下吧。",
    likes: "876",
    replies: "302",
  },
  {
    id: "dis-4",
    name: "冷静看瓜小组",
    avatar: "冷",
    time: "3 小时前",
    content: "工作室那份声明和本人一贯的说法确实有出入，但也不排除是措辞习惯问题，先继续观察后续有没有更新。",
    likes: "654",
    replies: "188",
  },
  {
    id: "dis-5",
    name: "路过的数据党",
    avatar: "数",
    time: "4 小时前",
    content: "做了个简单对比，热度峰值出现的时间和截图最早的传播时间点基本吻合，感兴趣的可以去资源区看对比图。",
    likes: "521",
    replies: "97",
  },
];

export const footerColumns = [
  {
    title: "内容分区",
    links: ["最新爆料", "话题墙", "热议榜", "争议回顾"],
  },
  {
    title: "资源入口",
    links: ["时间线资料包", "高清图集", "关系图谱", "往期归档"],
  },
  {
    title: "参与互动",
    links: ["讨论区", "爆料提醒", "线索提交", "纠错反馈"],
  },
  {
    title: "关于本站",
    links: ["站点说明", "内容规范", "免责声明", "联系站长"],
  },
];